import React from "react";
import { Image, ImageBackground, Platform, StyleSheet, View } from "react-native";
import { background, birkenstockBackground, defaultLogo, Icons } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { useGlobalState } from "../../shared/state";
import { Styles } from "../../styles";
import SquareButton from "../../components/Buttons/generic-button/SquareButton";
import I18n from "../../i18nSets/i18n";

const Home: React.FC = (): JSX.Element => {
  const [currentScanner] = useGlobalState("currentScanner");
  const [currentUser] = useGlobalState("currentUser");
  const [language] = useGlobalState("language");
  const specialLogo = (currentScanner && currentScanner["special-logo"]) || undefined;

  const isBirkenstock = currentScanner && currentScanner.partner && currentScanner.partner?.toLowerCase() === "birkenstock";

  let logo: string | undefined;
  let logoStyle: any;
  if (specialLogo) {
    logo = currentScanner["special-logo"];
    logoStyle = styles.specialLogo;
  } else if (isBirkenstock) {
    logo = currentScanner["scanner-logo"];
    logoStyle = {
      width: "27%",
      height: "20%",
      resizeMode: "contain",
    };
  } else if (currentScanner && currentScanner["scanner-logo"]) {
    logo = currentScanner["scanner-logo"];
    logoStyle = styles.logo;
  } else logo = undefined;

  const getNextScreen = () => {
    if (currentScanner && currentScanner["mandatoryLogin"]) {
      if (currentUser) {
        return "NewScanGenderSelection";
      } else {
        if (Platform.OS === "web") {
          return "Login";
        } else {
          return "LoginModal";
        }
      }
    } else {
      return "NewScanGenderSelection";
    }
  };

  return (
    <ImageBackground source={isBirkenstock ? birkenstockBackground : background} style={Styles.backgroundImage}>
      <LayoutWrapper showHeaderCloseButton={false} showHeaderLogo={false} isHomeScreen={true}>
        <View style={styles.logoWrapper}>
          <View style={{ flex: 1 }} />
          <Image style={[logoStyle, { marginTop: "5%" }]} source={logo ? { uri: logo } : defaultLogo} />
          {isBirkenstock && (
            <View
              style={{
                marginTop: "2%",
                width: "30%",
                height: "35%",
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <SquareButton
                text={I18n.t("new scan", { locale: language })}
                color="#0e2288"
                navigateTo={"Consent"}
                navigateOptions={{ resetState: true }}
                deactivated={currentScanner === undefined}
                width="90%"
                height="30%"
                fontSize={36}
              />
              <Image source={Icons.translateIcon} style={styles.iconContainer} />
              <SquareButton
                text={I18n.t("selectLanguage", { locale: language })}
                color="white"
                navigateTo="LanguageSelectModal"
                navigateOptions={{ resetState: true }}
                deactivated={currentScanner === undefined}
                width="60%"
                textColor="#0e2288"
              />
            </View>
          )}
          <View style={{ flex: 1 }} />
        </View>
      </LayoutWrapper>
    </ImageBackground>
  );
};

export default Home;

const styles = StyleSheet.create({
  logoWrapper: {
    flex: 1,
    alignItems: "center",
    alignContent: "center",
  },
  logo: {
    width: "40%",
    height: "20%",
    resizeMode: "contain",
  },
  specialLogo: {
    width: "60%",
    height: "60%",
    resizeMode: "contain",
  },
  iconContainer: {
    height: "15%",
    width: "25%",
    marginTop: "15%",
    marginBottom: "5%",
    resizeMode: "contain",
  },
});
